// document.addEventListener('DOMContentLoaded', (event) => {
//   debugger;
//   // var check = sessionStorage.getItem("country");
//    // var country = geoplugin_countryCode();
//    var check = sessionStorage.getItem("country");
//   if (check != undefined && check != null && check != "") {
//     showCountryDiv(check);
//     console.log(sessionStorage.getItem("country"));
//   } else {
//     $.get("https://ipinfo.io/json", function (response) {
//       var country = response.country;
//       sessionStorage.setItem("country", response.country);
//       showCountryDiv(country);
//       console.log(sessionStorage.getItem("country"));
//     }, "jsonp");
//   }
// });

// function showCountryDiv(country) {
//   if (country == 'PK') {
//     $('.product__icon__text.spain').show();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000); // add 5 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.spain .today_date').html(shippingDates.split(' to ')[0]);
//   $('.spain .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'ES') {
//     $('.product__icon__text.spain').show();
//     $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//     function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000); // add 5 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.spain .today_date').html(shippingDates.split(' to ')[0]);
//   $('.spain .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'FR') {
//     $('.product__icon__text.spain').hide();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').show();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 6 * 24 * 60 * 60 * 1000); // add 6 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.france .today_date').html(shippingDates.split(' to ')[0]);
//   $('.france .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'DK') {
//     $('.product__icon__text.spain').hide();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').show();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 6 * 24 * 60 * 60 * 1000); // add 6 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.denmark .today_date').html(shippingDates.split(' to ')[0]);
//   $('.denmark .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else if (country == 'IT') {
//     $('.product__icon__text.spain').hide();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').show();
//   function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // add 7 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.italy .today_date').html(shippingDates.split(' to ')[0]);
//   $('.italy .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   } else (country == '') {
//     $('.product__icon__text.spain').show();
//      $('.product__block.shipping_date').show();
//     $('.product__icon__text.france').hide();
//     $('.product__icon__text.denmark').hide();
//     $('.product__icon__text.italy').hide();
//       function calculateShippingDates() {
//   const today = new Date();
//   const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//   const secondDate = new Date(today.getTime() + 5 * 24 * 60 * 60 * 1000); // add 5 days
//   // handle Sunday and Saturday
//   if (firstDate.getDay() === 0) {
//     firstDate.setDate(firstDate.getDate() + 1);
//   } else if (firstDate.getDay() === 6) {
//     firstDate.setDate(firstDate.getDate() + 2);
//   }
//   if (secondDate.getDay() === 0) {
//     secondDate.setDate(secondDate.getDate() + 1);
//   } else if (secondDate.getDay() === 6) {
//     secondDate.setDate(secondDate.getDate() + 2);
//   }
//   // format dates as "dd/mm"
//   const firstDateString = `${firstDate.getDate().toString().padStart(2, '0')}/${(firstDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   const secondDateString = `${secondDate.getDate().toString().padStart(2, '0')}/${(secondDate.getMonth() + 1).toString().padStart(2, '0')}`;
//   return `${firstDateString} to ${secondDateString}`;
// }
// setInterval(() => {
//   const shippingDates = calculateShippingDates();
//   $('.spain .today_date').html(shippingDates.split(' to ')[0]);
//   $('.spain .fianl_date').html(shippingDates.split(' to ')[1]);
// }, 500); // update every 5 seconds
//   }
// }
// ========================================Show on all countries =============================
// document.addEventListener("DOMContentLoaded", (event) => {
//   $(".product__icon__text.spain").hide();
//   // $(".product__block.shipping_date").show();
//   $(".product__icon__text.france").hide();
//   $(".product__icon__text.denmark").hide();
//   $(".product__icon__text.italy").show();
//   function calculateShippingDates() {
//     const today = new Date();
//     const firstDate = new Date(today.getTime() + 24 * 60 * 60 * 1000); // add 1 day
//     const secondDate = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // add 7 days
//     // handle Sunday and Saturday
//     if (firstDate.getDay() === 0) {
//       firstDate.setDate(firstDate.getDate() + 1);
//     } else if (firstDate.getDay() === 6) {
//       firstDate.setDate(firstDate.getDate() + 2);
//     }
//     if (secondDate.getDay() === 0) {
//       secondDate.setDate(secondDate.getDate() + 1);
//     } else if (secondDate.getDay() === 6) {
//       secondDate.setDate(secondDate.getDate() + 2);
//     }
//     // format dates as "dd/mm"
//     const firstDateString = `${firstDate
//       .getDate()
//       .toString()
//       .padStart(2, "0")}/${(firstDate.getMonth() + 1)
//       .toString()
//       .padStart(2, "0")}`;
//     const secondDateString = `${secondDate
//       .getDate()
//       .toString()
//       .padStart(2, "0")}/${(secondDate.getMonth() + 1)
//       .toString()
//       .padStart(2, "0")}`;
//     return `${firstDateString} to ${secondDateString}`;
//   }
//   setInterval(() => {
//     const shippingDates = calculateShippingDates();
//     $(".italy .today_date").html(shippingDates.split(" to ")[0]);
//     $(".italy .fianl_date").html(shippingDates.split(" to ")[1]);
//   }, 500); // update every 5 seconds
// });

document.addEventListener("DOMContentLoaded", (event) => {
  // Hide elements
  // document
  //   .querySelectorAll(".product__icon__text.spain")
  //   .forEach((el) => (el.style.display = "none"));
  // document
  //   .querySelectorAll(".product__icon__text.france")
  //   .forEach((el) => (el.style.display = "none"));
  // document
  //   .querySelectorAll(".product__icon__text.denmark")
  //   .forEach((el) => (el.style.display = "none"));
  // document
  //   .querySelectorAll(".product__icon__text.italy")
  //   .forEach((el) => (el.style.display = "block"));

  function calculateShippingDates() {
    const today = new Date();

    // 1. Calculate firstDate (+5 days)
    const firstDate = new Date(today);
    firstDate.setDate(today.getDate() + 5);

    // Adjust firstDate for weekend
    if (firstDate.getDay() === 0) { // Sunday -> Monday
      firstDate.setDate(firstDate.getDate() + 1);
    } else if (firstDate.getDay() === 6) { // Saturday -> Monday
      firstDate.setDate(firstDate.getDate() + 2);
    }

    // 2. Calculate secondDate relative to adjusted firstDate (+2 days)
    const secondDate = new Date(firstDate);
    secondDate.setDate(firstDate.getDate() + 2);

    // Adjust secondDate if it falls on a weekend
    if (secondDate.getDay() === 0) {
      secondDate.setDate(secondDate.getDate() + 1);
    } else if (secondDate.getDay() === 6) {
      secondDate.setDate(secondDate.getDate() + 2);
    }

    // Helper function to format as "dd/mm"
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      return `${day}/${month}`;
    };

    return `${formatDate(firstDate)} to ${formatDate(secondDate)}`;
  }

  const shippingDates = calculateShippingDates();
  const dates = shippingDates.split(" to ");

  const lang = (document.documentElement.lang || "es").toLowerCase().slice(0, 2);
  const d1 = `<span class="today_date">${dates[0]}</span>`;
  const d2 = `<span class="fianl_date">${dates[1]}</span>`;
  const inStockTexts = {
    es: `En stock, recíbelo entre el ${d1} y el ${d2}`,
    en: `In stock, get it between ${d1} and ${d2}`,
    fr: `En stock, recevez-le entre le ${d1} et le ${d2}`,
    de: `Auf Lager, Lieferung zwischen dem ${d1} und dem ${d2}`,
    it: `Disponibile, ricevilo tra il ${d1} e il ${d2}`,
    pt: `Em stock, receba-o entre ${d1} e ${d2}`,
    nl: `Op voorraad, ontvang het tussen ${d1} en ${d2}`,
    pl: `Dostępny, dostawa między ${d1} a ${d2}`,
  };
  const newInStockText = inStockTexts[lang] || inStockTexts.es;

  if (document.querySelector(".variant__countdown--in")) {
    document.querySelector(".variant__countdown--in").innerHTML =
      newInStockText;
  }

  document
    .querySelectorAll(".italy .today_date")
    .forEach((el) => (el.innerHTML = dates[0]));
  document
    .querySelectorAll(".italy .fianl_date")
    .forEach((el) => (el.innerHTML = dates[1]));

  // setInterval(() => {
  //   const shippingDates = calculateShippingDates();
  //   const dates = shippingDates.split(" to ");
  //   document
  //     .querySelectorAll(".italy .today_date")
  //     .forEach((el) => (el.innerHTML = dates[0]));
  //   document
  //     .querySelectorAll(".italy .fianl_date")
  //     .forEach((el) => (el.innerHTML = dates[1]));
  // }, 5000); // update every 5 seconds
});